// extracted by mini-css-extract-plugin
export var label = "Label-module--label--c64oe";